import { Form, Row, Col, Button, notification, Skeleton, Divider } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router';

import DiagnosticsForm from '@/components/Movements/Diagnostics/Form';
import DiagnosticsPartList from '@/components/Movements/Diagnostics/PartsList';
import TabContentWrapper from '@/components/_common/TabContentWrapper';
import { PageProps } from '@/types/PageProps';
import { useDiagnosticCreate } from '@/core/domain/workorder/Diagnostics/Diagnostics.hooks';
import {
  DiagnosticCreate,
  DiagnosticFormValues,
} from '@/core/domain/workorder/Diagnostics/Diagnostics.types';
import isAxiosError from '@/utils/retornator/isAxiosError';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { DateTimeFormat } from '@/utils/moment';

const CreateDiagnosticPage = ({ route }: PageProps) => {
  const history = useHistory();
  const [form] = Form.useForm<DiagnosticFormValues>();
  const intl = useIntl();

  const diagnosticMutation = useDiagnosticCreate();

  const handleSaveDiagnostic = async () => {
    try {
      const { vehicle, ...values } = await form.validateFields();

      const obj: DiagnosticCreate = {
        ...values,
        vehicleId: vehicle.id,
        entryDate: values.entryDate?.format(DateTimeFormat),
      };

      const data = await diagnosticMutation.mutateAsync(obj);

      history.push(`/app/movements/diagnostics/${data.id}`);
    } catch (err) {
      if (!isAxiosError(err)) {
        notification.error({
          message: intl.formatMessage({
            id: 'diagnostics.form.notification.error.title',
          }),
          description: intl.formatMessage({
            id: 'diagnostics.form.notification.error.description',
          }),
        });
      }
    }
  };

  return (
    <TabContentWrapper
      title={route.name}
      extra={
        <Button
          type="primary"
          loading={diagnosticMutation.isLoading}
          onClick={() => handleSaveDiagnostic()}
        >
          <FormattedMessage id="commons.form.button.save" />
        </Button>
      }
    >
      <Skeleton active loading={diagnosticMutation.isLoading}>
        <Form form={form}>
          <Row gutter={[36, 16]}>
            <Col xs={24} md={12}>
              <DiagnosticsForm form={form} isVehicleSelectable />
            </Col>
            <Col xs={24} md={12}>
              <DiagnosticsPartList />
            </Col>
          </Row>
        </Form>

        <Divider />

        <SpaceForButton>
          <ButtonBack path="/app/movements/diagnostics" />
        </SpaceForButton>
      </Skeleton>
    </TabContentWrapper>
  );
};

export default CreateDiagnosticPage;
